export interface NWDEnvironment {
  AUTH_ENABLED: boolean;
  DEBUG_OAUTH: boolean;
  DOMAINS_API: string;
  ENABLED_ROUTES: string;
  GROTESTORING_URL: string;
  IOTNET_HIDDEN: boolean;
  MAP_TILE_URL: string;
  NEWS_RSS_FEED_URL: string;
  NWD_API_BASE_URL: string;
  NWD_DASHBOARD_URL: string;
  NWD_NEWS_URL: string;
  PIWIK_SITEID: string;
  SELFSERVICE_ENABLED: boolean;
  SENTRY_DSN: string;
}

// TODO: Revisit env vars
//   * DOMAINS_API is needed by both the generated NWD API and SURFdomeinen API
//   * NWD_API_BASE_URL is not used much anymore and is not useable for the generated NWD API
const defaults: NWDEnvironment = {
  AUTH_ENABLED: true,
  DEBUG_OAUTH: false,
  DOMAINS_API: "http://mockdomeinen",
  ENABLED_ROUTES: "dashboard,news,domains",
  GROTESTORING_URL: "",
  IOTNET_HIDDEN: false,
  MAP_TILE_URL: "https://tile.openstreetmap.org/{z}/{x}/{y}.png", // Usage must comply with https://operations.osmfoundation.org/policies/tiles/
  NEWS_RSS_FEED_URL: "",
  NWD_API_BASE_URL: "http://mockApi/",
  NWD_DASHBOARD_URL: "",
  NWD_NEWS_URL: "",
  PIWIK_SITEID: "",
  SELFSERVICE_ENABLED: false,
  SENTRY_DSN: "",
};

let importedEnv: Env | undefined;
try {
  // when running the Angular app
  importedEnv = _NGX_ENV_;
} catch {
  // Jest and Storybook: fall through to defaults below
}

const buildEnvironment = (): NWDEnvironment => {
  if (!importedEnv) {
    // case for storybook, which doesn't have _NGX_ENV_ or import.meta.env
    return defaults;
  }

  return Object.keys(importedEnv)
    .filter((key) => key.startsWith("NWD_"))
    .reduce((acc, cur) => {
      const key = cur.replace(/^(NWD_)/, "");

      // Since all environment values are strings, we need to
      // convert some of them to booleans.
      // Expect booleans to be set as "true" or "false".
      const value = importedEnv[cur];
      switch (value) {
        case "true":
          acc[key] = true;
          break;
        case "false":
          acc[key] = false;
          break;
        default:
          acc[key] = value;
      }
      return acc;
    }, defaults);
};

export const ENV: NWDEnvironment = buildEnvironment();

export const apiUrl = (path: string): string => ENV.NWD_API_BASE_URL + path;
